import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { AppConfig } from '../models/app-config.model';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config: AppConfig = new AppConfig();

  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
    private http: HttpClient) {
    var request = new XMLHttpRequest();
    request.open('GET', `${this.baseHref}assets/settings/appConfig.json`, false); 
    request.send();

    if (request.status === 200) {
      this.config = JSON.parse(request.response) as AppConfig;
    } else {
      throw new Error('Error loading appConfig.json');
    }
  }

  public getConfig(): AppConfig {
    return this.config;
  }
}
